"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineStyleTabLabel = exports.LineStylePreview = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const HrLine_1 = require("./hr/HrLine");
const PREVIEW_WIDTH = 24;
const previewWrapClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    w: `${PREVIEW_WIDTH}px`,
    minH: '16px',
});
/**
 * Tiny horizontal stroke preview used inside option pickers to show what
 * each line-style choice looks like (solid / dashed / dotted / squiggly).
 */
const LineStylePreview = ({ style, strokeWidth = 2 }) => (React.createElement("span", { className: previewWrapClass, "aria-hidden": "true" },
    React.createElement(HrLine_1.HrLine, { strokeWidth: strokeWidth, style: style })));
exports.LineStylePreview = LineStylePreview;
const LineStyleTabLabel = ({ style, label, strokeWidth = 2 }) => (React.createElement("span", { role: "img", title: label, "aria-label": label, style: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center' } },
    React.createElement(exports.LineStylePreview, { style: style, strokeWidth: strokeWidth })));
exports.LineStyleTabLabel = LineStyleTabLabel;
